"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.success.title': 'Account Activated!',
    'activate.success.description': 'Your account has been successfully activated. You can now sign in and start using IntHub.',
    'activate.success.message': 'Account activated successfully!',
};
